import { Button } from "@/components/ui/button";
import { getFileUrl } from "@/lib/file.util";
import { Event } from "@/lib/types/event";
import { MapPin, Calendar } from "lucide-react";
import Link from "next/link";

interface EventCardProps {
  event: Event;
  index: number;
}

export default function EventCard({ event, index }: EventCardProps) {
  const formatDate = (date: string | Date | object) => {
    if (typeof date === 'string') {
      return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    } else if (date instanceof Date) {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    }
    return 'Date not available';
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col h-full">
      <div className="aspect-video overflow-hidden">
        <img
          src={getFileUrl(event.thumbnail) || "/placeholder.svg"}
          alt={event.title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
        />
      </div>

      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-1 text-green-600">
            <MapPin className="h-4 w-4" />
            <span className="text-sm font-medium">{event.location}</span>
          </div>
          <div className="flex items-center gap-1 text-gray-500">
            <Calendar className="h-4 w-4" />
            <span className="text-sm">{formatDate(event.date)}</span>
          </div>
        </div>
        
        <h3 className="text-xl font-semibold text-gray-900 mb-3 line-clamp-2">
          {event.title}
        </h3>
        
        <p className="text-gray-600 mb-4 line-clamp-3">
          {event.description}
        </p>
        
        <Button asChild className="w-full mt-auto">
          <Link href={`/events/${event.id}`}>
            View Details
          </Link>
        </Button>
      </div>
    </div>
  );
} 